<template>
  <div class="wrp">
    <div class="invoice-update-wrp">
      <div v-if="newInvoiceList.length > 0" class="img-header">
        <div class="big-img">
        <img :src="getThumbnail(selectImg)"/>
      </div>
      <div class="img-list">
        <div>
          <div :class="['mini-img', selectImgId === index ? 'select-img' : '']" v-for="(i, index) in newInvoiceList" :key="i.url" @click="handleClickImg(i, index)">
            <img :src="getThumbnail(i.url)"/>
          </div>
        </div>
      </div>
        <div class="all-img-confirm">
          <div>共扫描成功 {{this.newInvoiceList.length}} 张发票 </div>
          <div @click="handleAllConfirm">全部确认</div>
        </div>
        <div v-if="imgTipsShow" class="img-tips huisuiyunfont">
          <div>以下扫描结果均可编辑</div>
          <div @click="() => this.imgTipsShow = false">{{'\ue8fe'}}</div>
        </div>
        <div v-if="imgTipsShow2" class="img-tips-red huisuiyunfont">
          <div>主体金额与明细合集金额不一致，请核对</div>
          <!-- <div @click="() => this.imgTipsShow2 = false">{{'\ue8fe'}}</div> -->
        </div>
      </div>
      <p v-if="newInvoiceList.length > 0" class="tips">
        请确认发票信息是否与票面相符
      </p>

      <van-cell-group :border="false">
        <van-field
          label="票据类型"
        >
          <input slot="input" class="input" type="text" v-model="invoiceInfo.invoiceTypeName" placeholder="请选择发票类型" readonly>
        </van-field>
      </van-cell-group>

      <van-cell-group v-show="invoiceInfo.purchaserName">
        <van-field
          label="购方名称"
          v-model="editData.purchaserName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.sellerName">
        <van-field
          label="销方名称"
          v-model="editData.sellerName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.invoiceCode">
        <van-field
          label="发票代码"
          v-model="editData.invoiceCode"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          label="发票号码"
          v-model="editData.invoiceNo"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.passengerName">
        <van-field
          label="乘客姓名"
          v-model="editData.passengerName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.mileage">
        <van-field
          label="里程"
          v-model="editData.mileage"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.getOnDate">
        <!-- <van-field
          label="乘车日期"
          v-models="editData.getOnDate"
        /> -->
        <div @click="monthShow = true" class="drew-date">
          <span :style="{ paddingLeft: '16px', color: '#333', fontSize: '14px' }">乘车日期</span>
          <span v-show="!monthShow" :style="{ fontSize: '14px' }">{{ editData.getOnDate }}</span>
        </div>
        <van-calendar v-model="monthShow" :min-date="new Date(1980, 0, 1)" @confirm="(data) => onConfirm(data, 'getOnDate')" color="#1989fa" :default-date="new Date(editData.getOnDate)" />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.trainNumber">
        <van-field
          label="车次"
          v-model="editData.trainNumber"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.seat">
        <van-field
          label="座位类型"
          v-model="editData.seat"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.stationGetOn">
        <van-field
          label="上车车站"
          v-model="editData.stationGetOn"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.stationGetOff">
        <van-field
          label="下车车站"
          v-model="editData.stationGetOff"
        />
      </van-cell-group>
      <van-cell-group>
        <!-- <van-field
          label="开票日期"
          v-models="editData.drewDate"
        /> -->
        <div @click="monthShow = true" class="drew-date">
          <span :style="{ paddingLeft: '16px', color: '#333', fontSize: '14px' }">开票日期</span>
          <span v-show="!monthShow" :style="{ fontSize: '14px' }">{{ editData.drewDate }}</span>
        </div>
        <van-calendar v-model="monthShow" :min-date="new Date(1980, 0, 1)" @confirm="(data) => onConfirm(data, 'drewDate')" color="#1989fa" :default-date="new Date(editData.drewDate)" />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.amountWithTax">
        <van-field
          label="金额（含税）"
          v-model="editData.amountWithTax"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.fare">
        <van-field
          label="票价"
          v-model="editData.fare"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.totalTax">
        <van-field
          label="税费"
          v-model="editData.totalTax"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.timeGetOn">
        <van-field
          label="上车时间"
          v-model="editData.timeGetOn"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.timeGetOff">
        <van-field
          label="下车时间"
          v-model="editData.timeGetOff"
        />
      </van-cell-group>
      <van-cell-group
        v-show="invoiceInfo.amount"
      >
        <van-field
          label="不含税金额"
          v-model="editData.amount"
        />
      </van-cell-group>
      <van-cell-group
        v-show="invoiceInfo.checkCode"
      >
        <van-field
          :label="invoiceInfo.invoiceType === '202' ? '验证码' : '校验码'"
          v-model="editData.checkCode"
        />
      </van-cell-group>
    </div>
    <MyActionSheet
      :columns="invoiceList"
      :visible="invoiceVisible"
      @cancel="invoiceVisible = false"
      @confirm="onInvoiceTypeConfirm"
      type="invoiceType"
    />
    <MyActionSheet
      :columns="companyNameList"
      :visible="companyData.visible"
      @cancel="companyData.visible = false"
      @confirm="onCompanyConfirm"
      type="companyList"
    />
    <MyActionSheet
      :columns="tagList"
      :visible="tagVisible"
      @cancel="tagVisible = false"
      @confirm="onTagConfirm"
      type="tag"
    />
    <div class="btn-wrp">
      <van-button
        class="btn"
        round
        @click="handleDel"
      >
        删除
      </van-button>
      <van-button
        class="btn"
        round
        @click="save"
      >
        保存
      </van-button>
    </div>
  </div>
</template>

<script>
import { CellGroup, Button, Toast, Notify, Popup, Icon, Field, Cell, Calendar } from 'vant'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'
import { officialAccountRequest, accountRequest } from '@services'
import UploadService from '@services/UploadService'
import { deepCopy, isEmpty } from '@utils/basicUtil'
import { BIG_THUMBNAIL_CONFIG } from '@/assets/config'
export default {
  data: () => ({
    newInvoiceList: [],
    monthShow: false,
    imgTipsShow2: false,
    selectImg: '',
    selectImgId: '',
    invoiceInfo: {},
    imgTipsShow: true,
    invoiceType: '01',
    submitType: '',
    submitData: {
      officialAccountId: '',
      imagePath: ''
    },
    companyData: {
      visible: false,
      companyId: ''
    },
    editData: {},
    companyList: [],
    companyNameList: [],
    tagList: [
      { name: '餐费' },
      { name: '招待费' },
      { name: '差旅费' },
      { name: '通讯费' },
      { name: '交通费' }
    ],
    invoiceList: [
      {
        name: '增值税专用发票',
        id: '01'
      },
      {
        name: '增值税普通发票',
        id: '04'
      },
      {
        name: '增值税电子发票',
        id: '10'
      },
      {
        name: '增值税卷式发票',
        id: '11'
      },
      {
        name: '增值税电子专用发票',
        id: '08'
      },
      {
        name: '数电专用发票',
        id: '09'
      },
      {
        name: '数电普通发票',
        id: '90'
      },
      {
        name: '航空客票行程单',
        id: '202'
      },
      {
        name: '定额发票',
        id: '200'
      },
      {
        name: '火车票',
        id: '201'
      },
      {
        name: '出租车发票',
        id: '207'
      }
    ],
    invoiceVisible: false,
    tagVisible: false
  }),
  computed: {
    getThumbnail () {
      return (url) => {
        // THUMBNAIL_CONFIG
        return BIG_THUMBNAIL_CONFIG(url)
      }
    },
    invoiceImageData: (vm) => {
      return vm.$store.state.invoice.invoiceImageData
    },
    ossUrlList: (vm) => {
      return vm.$store.state.invoice.ossUrlList
    },
    userInfo: (vm) => {
      return vm.$store.state.user.company
    }
  },
  watch: {
    userInfo () {
      if (this.userInfo.id) {
        this.submitData.officialAccountId = this.userInfo.id
      }
    }
  },
  mounted () {
    this.discern()
  },
  methods: {
    onConfirm (data, key) {
      let newData = new Date(data)
      if (key === 'drewDate') {
        this.editData.drewDate = `${newData.getFullYear()}-${(newData.getMonth() + 1) >= 10 ? (newData.getMonth() + 1) : ('0' + (newData.getMonth() + 1))}-${newData.getDate() >= 10 ? newData.getDate() : ('0' + (newData.getDate()))}`
      } else {
        this.editData.getOnDate = `${newData.getFullYear()}-${(newData.getMonth() + 1) >= 10 ? (newData.getMonth() + 1) : ('0' + (newData.getMonth() + 1))}-${newData.getDate() >= 10 ? newData.getDate() : ('0' + (newData.getDate()))}`
      }
      this.monthShow = false
    },
    handleInit () {
      this.selectImg = this.newInvoiceList[0].url
      this.selectImgId = 0
      if (this.newInvoiceList[0].vatFlag === '1') {
        this.nonVatTicket(this.newInvoiceList[0].nonVatTicketDiscern)
        this.invoiceType = 'nonVat'
      } else {
        this.vatTicket(this.newInvoiceList[0].vatTicketDiscern)
        this.invoiceType = 'vat'
      }
    },
    handleDel () {
      if (this.newInvoiceList.length === 1) {
        this.goBack()
        return
      }
      this.newInvoiceList = this.newInvoiceList.filter((item, i) => {
        return i !== this.selectImgId
      })
      this.handleInit()
    },
    async handleAllConfirm () {
      if (this.editData.customRemark && this.editData.customRemark.length > 32) {
        return Notify({ type: 'danger', message: '备注字段不能超过32个字符' })
      }
      if (!this.testField('invoiceTypeName') || !this.testField('purchaserName') || !this.testField('sellerName') || !this.testField('invoiceCode') || !this.testField('invoiceNo') || !this.testField('passengerName') || !this.testField('mileage') || !this.testField('getOnDate') || !this.testField('trainNumber') || !this.testField('stationGetOn') || !this.testField('stationGetOff') || !this.testField('drewDate') || !this.testField('amountWithTax') || !this.testField('fare') || !this.testField('totalTax') || !this.testField('amount') || !this.testField('checkCode')) {
        return
      }
      this.setInoiceList()
      let query = []
      let newQuery = []
      let repeatInvoice = []
      let invoiceCodeNos = []
      this.newInvoiceList.map(item => {
        let obj = {}
        let codeNo = ''
        if (item.vatFlag === '1') {
          obj = {
            ...item.nonVatTicketDiscern,
            filePath: item.url,
            vatFlag: item.vatFlag,
            dataSource: '7'
          }
          codeNo = (obj.invoiceCode || '') + (obj.invoiceNo || '')
        } else {
          obj = {
            ...item.vatTicketDiscern,
            filePath: item.url,
            vatFlag: item.vatFlag,
            dataSource: '7'
          }
          codeNo = (obj.invoiceCode || '') + (obj.invoiceNo || '')
        }
        invoiceCodeNos.push(codeNo)
        query.push(obj)
      })
      // 校验是否有相同的发票
      const noRepeatLength = Array.from(new Set(invoiceCodeNos)).length
      if (noRepeatLength !== invoiceCodeNos.length) return Notify({ type: 'danger', message: '当前发票中存在相同发票，请检查' })
      // 调用接口查看是否重复发票， 与库对比
      const checkResult = await officialAccountRequest.weChat.checkRepeat({ invoiceCodeNos })
      if (checkResult.result && checkResult.result.length) {
        Notify({ type: 'danger', message: '当前选中发票包含重复发票，非重复发票已保存成功，重复发票请检查票面信息无误后再保存' })
        // 选中的全部发票,进行过滤对比code+no 不存在进入查验，存在进入重复集合
        query.forEach(item => {
          let itemCodeNo = (item.invoiceCode || '') + (item.invoiceNo || '')
          let flag = checkResult.result.find(i => i.invoiceCodeNo === itemCodeNo)
          if (!flag) {
            newQuery.push(item)
          } else {
            repeatInvoice.push(item)
          }
        })
      } else {
        newQuery = query
      }
      Toast.loading({
        message: '全部上传中...',
        forbidClick: true,
        duration: 0
      })
      let res = await officialAccountRequest.weChat.saveCollections(newQuery)
      if (res.success) {
        if (query.length === newQuery.length) {
          // 相等代表没有重复的发票
          Notify({ type: 'success', message: '采集成功' })
          this.$router.push('/ticket/center/index')
        } else {
          // 有重复的,接着按照code+no判断
          let invoiceList = []
          this.newInvoiceList.forEach(listItem => {
            let listCodeNo = ''
            if (listItem.vatFlag === '1') {
              listCodeNo = (listItem.nonVatTicketDiscern.invoiceCode || '') + (listItem.nonVatTicketDiscern.invoiceNo || '')
            } else {
              listCodeNo = (listItem.vatTicketDiscern.invoiceCode || '') + (listItem.vatTicketDiscern.invoiceNo || '')
            }
            const flag = repeatInvoice.find(repeatItem => {
              let repeatCodeNo = (repeatItem.invoiceCode || '') + (repeatItem.invoiceNo || '')
              return repeatCodeNo === listCodeNo
            })
            // find到了数据标示这条数据重复了
            if (flag) invoiceList.push(listItem)
          })
          this.newInvoiceList = invoiceList
          // 取第一条的数据
          if (this.newInvoiceList.length > 0) {
            this.selectImg = this.newInvoiceList[0].url
            this.selectImgId = 0
            if (this.newInvoiceList[0].vatFlag === '1') {
              this.nonVatTicket(this.newInvoiceList[0].nonVatTicketDiscern)
              this.invoiceType = 'nonVat'
            } else {
              this.vatTicket(this.newInvoiceList[0].vatTicketDiscern)
              this.invoiceType = 'vat'
            }
          } else {
            Toast.clear({
              clearAll: true
            })
            Notify({ type: 'success', message: '采集成功' })
            this.$router.push('/ticket/center/index')
          }
        }
      } else {
        Notify({ type: 'danger', message: res.message })
      }
      Toast.clear({
        clearAll: true
      })
    },
    handleClickImg (i, index) {
      this.setInoiceList()
      this.selectImg = i.url
      this.selectImgId = index
      if (this.newInvoiceList[index].vatFlag === '1') {
        this.nonVatTicket(this.newInvoiceList[index].nonVatTicketDiscern)
        this.invoiceType = 'nonVat'
      } else {
        this.vatTicket(this.newInvoiceList[index].vatTicketDiscern)
        this.invoiceType = 'vat'
      }
    },
    setInoiceList () {
      if (this.newInvoiceList[this.selectImgId].vatFlag === '1') {
        this.newInvoiceList[this.selectImgId].nonVatTicketDiscern = this.editData
      } else {
        this.newInvoiceList[this.selectImgId].vatTicketDiscern = this.editData
      }
    },
    async getCompanies () {
      const postData = {
        size: 9999
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        this.companyList = data.result
        let companyNameList = []
        this.companyList.forEach(item => {
          companyNameList.push({ name: item.companyName, id: item.id })
        })
        this.companyNameList = companyNameList
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async discern () {
      Toast.loading({
        message: '发票识别中...',
        forbidClick: true,
        duration: 0
      })
      this.invoiceInfo = {}
      const data = await officialAccountRequest.weChat.batchCollection({ paths: this.ossUrlList })
      console.log(data)
      if (data.success) {
        console.log(data)
        if (data.result && data.result.length) {
          if (data.result[0].vatTicketDiscern && data.result[0].vatTicketDiscern.items) {
            let detailAmountWithTax = 0
            data.result[0].vatTicketDiscern.items.forEach(item => {
              detailAmountWithTax = detailAmountWithTax + (Number(item.amount) + Number(item.taxAmount))
            })
            console.log(detailAmountWithTax, Number(data.result[0].vatTicketDiscern.amountWithTax))
            console.log(detailAmountWithTax !== Number(data.result[0].vatTicketDiscern.amountWithTax))
            if (detailAmountWithTax.toFixed(2) !== Number(data.result[0].vatTicketDiscern.amountWithTax).toFixed(2)) {
              this.imgTipsShow2 = true
            }
          }
          this.newInvoiceList = data.result
          this.selectImg = data.result[0].url
          this.selectImgId = 0
          if (data.result[0].vatFlag === '1') {
            this.nonVatTicket(data.result[0].nonVatTicketDiscern)
            this.invoiceType = 'nonVat'
          } else {
            this.vatTicket(data.result[0].vatTicketDiscern)
            this.invoiceType = 'vat'
          }
        } else {
          Toast.clear({
            clearAll: true
          })
          Notify({ type: 'danger', message: '发票识别失败!' })
          this.goBack()
          return
        }
      } else {
        Toast.clear({
          clearAll: true
        })
        Notify({ type: 'danger', message: data.message })
        this.goBack()
        return
      }
      this.overlayVisible = true
      Toast.clear({
        clearAll: true
      })
    },
    uploadImage () {
      Toast.loading({
        message: '发票上传中...',
        forbidClick: true,
        duration: 0
      })
      return new Promise(async (resolve, reject) => {
        try {
          const data = await UploadService(this.invoiceImageData.file, '', true)
          if (data.success) {
            this.submitData.imagePath = data.fileUrl
            resolve()
          }
        } catch (e) {
          alert(e)
        }
      })
    },
    vatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '01':
          invoiceInfo.invoiceTypeName = '增值税专用发票'
          break
        case '04':
          invoiceInfo.invoiceTypeName = '增值税普通发票'
          break
        case '10':
          invoiceInfo.invoiceTypeName = '增值税电子发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        case '08':
          invoiceInfo.invoiceTypeName = '增值税电子专用发票'
          break
        case '09':
          invoiceInfo.invoiceTypeName = '数电专用发票'
          break
        case '90':
          invoiceInfo.invoiceTypeName = '数电普通发票'
          break
        case '85':
          invoiceInfo.invoiceTypeName = '数电纸质专用发票'
          break
        case '86':
          invoiceInfo.invoiceTypeName = '数电纸质普通发票'
          break
        case '14':
          invoiceInfo.invoiceTypeName = '通行费发票'
          break
        case '15':
          invoiceInfo.invoiceTypeName = '二手车发票'
          break
        case '03':
          invoiceInfo.invoiceTypeName = '机动车发票'
          break
        case '51':
          invoiceInfo.invoiceTypeName = '数电火车票'
          break
        case '61':
          invoiceInfo.invoiceTypeName = '数电飞机票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    nonVatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '202':
          invoiceInfo.invoiceTypeName = '航空客票行程单'
          break
        case '200':
          invoiceInfo.invoiceTypeName = '定额发票'
          break
        case '201':
          invoiceInfo.invoiceTypeName = '火车票'
          break
        case '207':
          invoiceInfo.invoiceTypeName = '出租车发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    submit () {
      this.submitType = 'saveAndCommit'
      this.saveAndCommit()
    },
    async save () {
      if (this.editData.customRemark && this.editData.customRemark.length > 32) {
        return Notify({ type: 'danger', message: '备注字段不能超过32个字符' })
      }
      if (!this.testField('invoiceTypeName') || !this.testField('purchaserName') || !this.testField('sellerName') || !this.testField('invoiceCode') || !this.testField('invoiceNo') || !this.testField('passengerName') || !this.testField('mileage') || !this.testField('getOnDate') || !this.testField('trainNumber') || !this.testField('stationGetOn') || !this.testField('stationGetOff') || !this.testField('drewDate') || !this.testField('amountWithTax') || !this.testField('fare') || !this.testField('totalTax') || !this.testField('amount') || !this.testField('checkCode')) {
        return
      }
      this.setInoiceList()
      let query = []
      let invoiceCodeNo = ''
      if (this.newInvoiceList[this.selectImgId].vatFlag === '1') {
        query.push(
          {
            ...this.newInvoiceList[this.selectImgId].nonVatTicketDiscern,
            vatFlag: this.newInvoiceList[this.selectImgId].vatFlag,
            filePath: this.newInvoiceList[this.selectImgId].url,
            dataSource: '7'
          }
        )
      } else {
        query.push(
          {
            ...this.newInvoiceList[this.selectImgId].vatTicketDiscern,
            vatFlag: this.newInvoiceList[this.selectImgId].vatFlag,
            filePath: this.newInvoiceList[this.selectImgId].url,
            dataSource: '7'
          }
        )
      }
      if (query[0].invoiceCode) {
        invoiceCodeNo += query[0].invoiceCode
      }
      if (query[0].invoiceNo) {
        invoiceCodeNo += query[0].invoiceNo
      }
      // 调用接口查看是否重复发票
      const checkResult = await officialAccountRequest.weChat.checkRepeat({ invoiceCodeNos: [invoiceCodeNo] })
      if (checkResult.result.length) {
        Notify({ type: 'danger', message: '该发票为重复发票，请核对' })
        return checkResult.result
      }
      Toast.loading({
        message: '单独上传中...',
        forbidClick: true,
        duration: 0
      })
      let res = await officialAccountRequest.weChat.saveCollections(query)
      if (res.success) {
        this.newInvoiceList = this.newInvoiceList.filter((item, i) => {
          return i !== this.selectImgId
        })
        if (this.newInvoiceList.length > 0) {
          this.selectImg = this.newInvoiceList[0].url
          this.selectImgId = 0
          if (this.newInvoiceList[0].vatFlag === '1') {
            this.nonVatTicket(this.newInvoiceList[0].nonVatTicketDiscern)
            this.invoiceType = 'nonVat'
          } else {
            this.vatTicket(this.newInvoiceList[0].vatTicketDiscern)
            this.invoiceType = 'vat'
          }
        } else {
          Toast.clear({
            clearAll: true
          })
          Notify({ type: 'success', message: '采集成功' })
          this.$router.push('/ticket/center/index')
        }
      } else {
        Notify({ type: 'danger', message: res.message })
      }
      Toast.clear({
        clearAll: true
      })
    },
    showCompanyPicker () {
      this.companyData.visible = true
    },
    onCompanyConfirm (data) {
      this.companyData.visible = false
      this.submitData.officialAccountId = data.value.id
      this.saveAndCommit()
    },
    onInvoiceTypeConfirm (data) {
      this.invoiceVisible = false
      this.invoiceInfo.invoiceType = data.value.id
      this.invoiceInfo.invoiceTypeName = data.value.name
    },
    onTagConfirm (data) {
      this.tagVisible = false
      this.editData.tag = data.value.name
    },
    findCompany (companyName) {
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].companyName === companyName) {
          return this.companyList[i]
        }
      }
    },
    async saveAndCommit () {
      await this.uploadImage()
      if (this.invoiceType === 'nonVat') {
        this.nonVatSaveAndCommit()
      } else {
        this.vatSaveAndCommit()
      }
    },
    async nonVatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.nonVatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async vatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.vatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    testField (type) {
      const fieldObj = {
        tag: '标签',
        invoiceTypeName: '票据类型',
        purchaserName: '购方名称',
        sellerName: '销方名称',
        invoiceCode: '发票代码',
        invoiceNo: '发票号码',
        passengerName: '乘客姓名',
        mileage: '里程',
        getOnDate: '乘车日期',
        trainNumber: '车次',
        seat: '座位类型',
        stationGetOn: '上车车站',
        stationGetOff: '下车车站',
        drewDate: '开票日期',
        amountWithTax: '金额（含税）',
        fare: '票价',
        totalTax: '税费',
        amount: '不含税金额',
        checkCode: this.editData.invoiceType === '202' ? '验证码' : '校验码'
      }
      const requireMap = {
        tag: ['all'],
        invoiceTypeName: [],
        purchaserName: ['01', '04', '10', '11'],
        sellerName: ['01', '04', '10', '11'],
        invoiceCode: ['200', '207', '01', '04', '10', '11'],
        invoiceNo: ['200', '207', '01', '04', '10', '11', '202', '201'],
        passengerName: ['202', '201'],
        mileage: ['207'],
        getOnDate: ['201'],
        trainNumber: ['201'],
        seat: ['201'],
        stationGetOn: ['201'],
        stationGetOff: ['201'],
        drewDate: ['01', '04', '10', '11', '202'],
        amountWithTax: ['200', '207', '01', '04', '10', '11', '202', '201'],
        fare: ['202'],
        totalTax: [],
        amount: ['01', '04', '10'],
        checkCode: ['04', '10', '11', '202']
      }
      if (isEmpty(this.editData[type]) && (requireMap[type].includes('all') || requireMap[type].includes(this.editData.invoiceType))) {
        Notify({ type: 'danger', message: `${fieldObj[type]}不能为空` })
        return false
      }
      return true
    },
    uploadError (message) {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'danger', message: `收票失败！${message}` })
      this.goBack()
    },
    closeLoading () {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'success', message: '收票成功！' })
      this.goBack()
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Calendar.name]: Calendar,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    MyActionSheet
  }
}
</script>

<style lang="less" scoped>

  /deep/.van-calendar__selected-day{
    width: 100%;
    padding: 20px 0;
  }
  /deep/.van-calendar__day{
    padding: 20px 0;
  }
  /deep/.van-calendar__bottom-info{
    padding-bottom: 10px;
  }
  /deep/.van-calendar__day--start {
    border-top-left-radius: 8px;
    background-color: rgb(69, 115, 222);
    border-bottom-left-radius: 8px;
  }
  /deep/.van-calendar__day--middle{
    background-color: rgba(69, 115, 222, .1);
    color: rgb(69, 115, 222);
  }
  /deep/.van-calendar__day--end {
    border-top-right-radius: 8px;
    background-color: rgb(69, 115, 222);
    border-bottom-right-radius: 8px;
  }
  .wrp {
    height: 100%;
    color: rgba(31, 36, 51, 1);
    font-family: Alibaba PuHuiTi;
    background-color: white;
  }
  /deep/.van-cell-group {
    box-sizing: border-box;
    padding: 4px 8px;
  }
  .tips {
    font-size: 24px;
    color: #999;
    margin: 10px 40px;
  }
  .border-btm {
    border-bottom: 1px solid #eff2f2;
  }
  .margin-btm {
    margin-bottom: 30px;
    border-bottom: 20px solid #eff2f2;
  }
  .input {
    font-size: 26px;
    font-family: "PingFang SC";
    font-weight: 500;
    width: 100%;
    text-align: right;
    border: none;
    margin: 0;
  }
  .larger-input {
    height: 200px;
  }
  /deep/.van-field__label {
    color: #333;
    width: 200px;
  }
  .invoice-update-wrp {
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 200px;
  }
  /deep/.van-field__control {
    text-align: right;
  }
  /deep/.btn.cancel {
    background: white;
  }
  .btn-wrp{
    display: flex;
    justify-content: space-evenly;
    padding: 40px 20px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    width: 100%;
    .btn{
      width: 330px;
      height: 90px;
      background: #D4D6DC;
      border-radius: 12px;
      color: #fff;
      font-size: 32px;
      font-weight: 500;
      text-align: center;
    }
    .btn:nth-child(2){
      background: #2372FF;
      color: #fff;
    }
  }
  .big-img{
    margin: 0 auto;
    width: 718px;
    height: 400px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-list{
    margin-top: 8px !important;
    // background: red;
    width: 718px;
    margin: 0 auto;
    height: 104px;
  }
  .img-list>div{
    display: flex;
    overflow-x: scroll;
    .mini-img{
      flex-shrink: 0;
      border: 2Px solid transparent;
      width: 160px;
      height: 104px;
      margin-right: 8px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .select-img{
    border: 2Px solid rgba(51, 120, 255, 1) !important;
  }
  .all-img-confirm {
    display: flex;
    margin-top: 24px;
    justify-content: space-between;
    padding: 0px 24px;
    height: 94px;
    align-items: center;
    box-sizing: border-box;
    font-size: 30px;
    background: #fff;
  }
  .all-img-confirm>div:last-of-type{
    color: rgba(51, 120, 255, 1);
  }
  .img-tips{
    height: 64px;
    display: flex;
    align-items: center;
    font-size: 26px;
    justify-content: space-between;
    color: rgba(51, 120, 255, 1);
    padding: 0 24px;
    box-sizing: border-box;
    background: rgba(51, 120, 255, 0.08);
  }
  .img-tips-red{
    height: 64px;
    display: flex;
    align-items: center;
    font-size: 26px;
    justify-content: space-between;
    color: rgb(207, 70, 70);
    padding: 0 24px;
    box-sizing: border-box;
    background: rgba(202, 70, 90, 0.18);
  }
  .img-header{
    background: rgba(245, 245, 245, 1);
  }
  /deep/.van-calendar__popup.van-popup--bottom, .van-calendar__popup.van-popup--top {
    height: 40%;
  }
  .drew-date{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    span{
      font-size: 14px;
      color: #333;
      padding-right: 32px;
    }
  }
  /deep/.van-calendar__confirm{
    height: 60px;
  }
</style>
